import * as yup from "yup";
import YupPassword from "yup-password";

YupPassword(yup);

export const password = (fieldName = "Password") =>
  yup
    .string()
    .password()
    .min(8, `${fieldName} must contain at least 8 characters`)
    .minLowercase(1, `${fieldName} must contain at least 1 lowercase character`)
    .minUppercase(1, `${fieldName} must contain at least 1 uppercase character`)
    .minNumbers(1, `${fieldName} must contain at least 1 digit`)
    .minSymbols(1, `${fieldName} must contain at least 1 symbol`)
    .required(`${fieldName} is required`);
